<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.texts.dashboard.signatures.title') }}
    </h1>
    <p>{{ $t('documentation.texts.dashboard.signatures.paragraph1') }}</p>
    <h2 class="primary--text">
      {{ $t('documentation.texts.dashboard.signatures.title1') }}
    </h2>
    <v-img
      style="
        width: 100%;
        max-width: 600px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic1Name"
    />
    <p>{{ $t('documentation.texts.dashboard.signatures.paragraph2') }}</p>
    <ul>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.signatures.li1Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.signatures.li1') }}
      </li>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.signatures.li2Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.signatures.li2') }}
      </li>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.signatures.li3Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.signatures.li3') }}
      </li>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.signatures.li4Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.signatures.li4') }}
      </li>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.signatures.li5Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.signatures.li5') }}
      </li>
      <li>
        <b>
          {{ $t('documentation.texts.dashboard.signatures.li6Title') }}
        </b>
        {{ $t('documentation.texts.dashboard.signatures.li6') }}
      </li>
    </ul>
    <p>{{ $t('documentation.texts.dashboard.signatures.paragraph3') }}</p>
    <br />
    <h2 class="primary--text">
      {{ $t('documentation.texts.dashboard.signatures.title2') }}
    </h2>
    <v-img
      style="
        width: 100%;
        max-width: 800px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic2Name"
    />
    <p>{{ $t('documentation.texts.dashboard.signatures.paragraph4') }}</p>
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/dashboard/' +
        this.$t('documentation.texts.dashboard.signatures.pic1') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/dashboard/' +
        this.$t('documentation.texts.dashboard.signatures.pic2') +
        '.png')
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
